import { delay, http, HttpResponse } from 'msw';

import { aFolder } from '@sbu/views.nav/build/mocks';

const getRandomFolders = (folderCount: number) => {
  return new Array(folderCount).fill({}).map((_, index) =>
    aFolder({
      id: index,
      name: `Folder-${index + 1}`,
      parentId: index + 10,
      type: 'folder',
    })
  );
};

export const handlers = [
  http.get('*/json/v2/content/folder/globalview', async () => {
    await delay();
    return HttpResponse.json({
      error: false,
      errorMessage: null,
      errorInstanceId: null,
      errorKey: null,
      keyedErrors: [],
      adminRecommended: {
        accessKey: null,
        name: 'Admin Recommended',
        id: 146934010,
        type: 'folder',
        parentId: 0,
        visibility: 'USER',
        ownerName: '',
        runAsIdOverride: null,
        __typename: 'Folder',
      },
      users: {
        id: -1,
        name: 'Users',
        parentId: 0,
        type: 'folder',
        children: getRandomFolders(1000),
      },
    });
  }),
];
